import { render, staticRenderFns } from "./pcell.vue?vue&type=template&id=978a077a&scoped=true"
import script from "./pcell.vue?vue&type=script&lang=js"
export * from "./pcell.vue?vue&type=script&lang=js"
import style1 from "./pcell.vue?vue&type=style&index=1&id=978a077a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978a077a",
  null
  
)

export default component.exports